<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hVJhb9/tc-custom/9783958643307_IMGJPG_FrontCover_0.jpg?1703129215419" alt="This image is the cover for the book Dantons Tod, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dantons Tod, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Karl Georg Büchner (* 17. Oktober 1813 in Goddelau, Großherzogtum Hessen; † 19. Februar 1837 in Zürich) war ein hessischer Schriftsteller, Mediziner, Naturwissenschaftler und Revolutionär. Er gilt trotz seines schmalen Werkes – er starb bereits im Alter von 23 Jahren – als einer der bedeutendsten Literaten des Vormärz. Teile seines Werkes zählen zur Exilliteratur. (Auszug aus Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Georg Büchner
      </h2>
      
      <p class="authorDescription body article">Karl Georg Büchner (* 17. Oktober 1813 in Goddelau, Großherzogtum Hessen; † 19. Februar 1837 in Zürich) war ein deutscher Schriftsteller, Mediziner, Naturwissenschaftler und Revolutionär. Er gilt trotz seines schmalen Werkes – er starb bereits im Alter von 23 Jahren – als einer der bedeutendsten Literaten des Vormärz. Teile seines Werkes zählen zur Exilliteratur. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB Ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a17e4db